import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InternationalizationComponent } from './internationalization/internationalization.component';

const routes: Routes = [
  { path: '', redirectTo: `${localStorage.Language ? localStorage.Language : 'ar'}/home`, pathMatch: 'full' },

  {
    path: ':languageCode',
    component: InternationalizationComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        data: { title: { en: 'Elite | Home', ar: 'Elite | الرئيسية' } }
      },
      {
        path: 'why-elite',
        loadChildren: () => import('./why-elite/why.module').then((m) => m.WhyModule),
        data: { title: { en: 'Elite | Why Elite ', ar: 'Elite | لماذا النخبة' } }
      },
      {
        path: 'contact-us',
        loadChildren: () => import('./contact-us/contact.module').then((m) => m.ContactModule),
        data: { title: { en: 'Elite | Contact', ar: 'Elite | تواصل معنا' } }
      },
      {
        path: 'careers',
        loadChildren: () => import('./career/career.module').then((m) => m.CareerModule),
        data: { title: { en: 'Elite | Careers', ar: 'Elite | وظائف' } }
      },
      {
        path: 'services',
        loadChildren: () => import('./services/services.module').then((m) => m.ServicesModule),
        data: { title: { en: 'Elite | Services', ar: 'Elite | الخدمات' } }
      },
      {
        path: 'services-details/:serviceId',
        loadChildren: () => import('./services/service-details/service-details.module').then((m) => m.ServiceDetailsModule),
        data: { title: { en: 'Elite | Service', ar: 'Elite | الخدمة' } }
      },
      {
        path: 'portal',
        loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule),
        data: { title: { en: 'Elite | Portal', ar: 'Elite | بوابة العميل' } }
      },
      {
        path: 'policies',
        loadChildren: () => import('./policy/all-terms.module').then((m) => m.AllTermsModule)
      },
      { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: `${localStorage.Language ? localStorage.Language : 'ar'}/home`, pathMatch: 'full' },
  {
    path: '**',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      relativeLinkResolution: 'legacy',
      // scrollPositionRestoration: "enabled",
      initialNavigation: 'enabledBlocking'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
